import * as Yup from 'yup';

const ClinicThresholdSchema = Yup.object()
  .shape({
    minCriticalSystolic: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .lessThan(
        Yup.ref('maxCriticalSystolic'),
        'Must be less than Max Critical',
      )
      .required(),
    maxCriticalSystolic: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .moreThan(
        Yup.ref('minCriticalSystolic'),
        'Must be more than Min Critical',
      )
      .required(),
    minRiskSystolic: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .lessThan(Yup.ref('maxRiskSystolic'), 'Must be less than Max at Risk')
      .moreThan(
        Yup.ref('minCriticalSystolic'),
        'Must be more than Min Critical',
      )
      .required(),
    maxRiskSystolic: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .moreThan(Yup.ref('minRiskSystolic'), 'Must be more than Min at Risk')
      .lessThan(
        Yup.ref('maxCriticalSystolic'),
        'Must be less than Max Critical',
      )
      .required(),
    minCriticalDiastolic: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .lessThan(
        Yup.ref('maxCriticalDiastolic'),
        'Must be less than Max Critical',
      )
      .required(),
    maxCriticalDiastolic: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .moreThan(
        Yup.ref('minCriticalDiastolic'),
        'Must be more than Min Critical',
      )
      .required(),
    minRiskDiastolic: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .lessThan(Yup.ref('maxRiskDiastolic'), 'Must be less than Max at Risk')
      .moreThan(
        Yup.ref('minCriticalDiastolic'),
        'Must be more than Min Critical',
      )
      .required(),
    maxRiskDiastolic: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .moreThan(Yup.ref('minRiskDiastolic'), 'Must be more than Min at Risk')
      .lessThan(
        Yup.ref('maxCriticalDiastolic'),
        'Must be less than Max Critical',
      )
      .required(),
    minCriticalPulse: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .lessThan(Yup.ref('maxCriticalPulse'), 'Must be less than Max Critical')
      .required(),
    maxCriticalPulse: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .moreThan(Yup.ref('minCriticalPulse'), 'Must be more than Min Critical')
      .required(),
    minCriticalSleepPulse: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .lessThan(
        Yup.ref('maxCriticalSleepPulse'),
        'Must be less than Max Critical',
      )
      .required(),
    maxCriticalSleepPulse: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .moreThan(
        Yup.ref('minCriticalSleepPulse'),
        'Must be more than Min Critical',
      )
      .required(),
    minRiskPulse: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .lessThan(Yup.ref('maxRiskPulse'), 'Must be less than Max at Risk')
      .moreThan(Yup.ref('minCriticalPulse'), 'Must be more than Min Critical')
      .required(),
    maxRiskPulse: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .moreThan(Yup.ref('minRiskPulse'), 'Must be more than Min at Risk')
      .lessThan(Yup.ref('maxCriticalPulse'), 'Must be less than Max Critical')
      .required(),
    minRiskSleepPulse: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .lessThan(Yup.ref('maxRiskSleepPulse'), 'Must be less than Max at Risk')
      .moreThan(
        Yup.ref('minCriticalSleepPulse'),
        'Must be more than Min Critical',
      )
      .required(),
    maxRiskSleepPulse: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(200, 'Must be less than 200')
      .moreThan(Yup.ref('minRiskSleepPulse'), 'Must be more than Min at Risk')
      .lessThan(
        Yup.ref('maxCriticalSleepPulse'),
        'Must be less than Max Critical',
      )
      .required(),
    criticalBloodoxygen: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(100, 'Must be less than 100')
      .lessThan(Yup.ref('riskBloodoxygen'), 'Must be less than At Risk')
      .required(),
    riskBloodoxygen: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(100, 'Must be less than 100')
      .moreThan(Yup.ref('criticalBloodoxygen'), 'Must be more than Critical')
      .required(),
    minCriticalGlucose: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(400, 'Must be less than 400')
      .lessThan(Yup.ref('minRiskGlucose'), 'Must be less than Min Risk')
      .required(),
    maxCriticalGlucose: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(400, 'Must be less than 400')
      .moreThan(Yup.ref('minCriticalGlucose'), 'Must be more than Min Critical')
      .required(),
    minRiskGlucose: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(400, 'Must be less than 400')
      .lessThan(Yup.ref('maxRiskGlucose'), 'Must be less than Max at Risk')
      .moreThan(Yup.ref('minCriticalGlucose'), 'Must be more than Min Critical')
      .required(),
    maxRiskGlucose: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(400, 'Must be less than 400')
      .moreThan(Yup.ref('minRiskGlucose'), 'Must be more than Min at Risk')
      .lessThan(Yup.ref('maxCriticalGlucose'), 'Must be less than Max Critical')
      .required(),
    minCriticalWeight: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .moreThan(Yup.ref('minRiskWeight'), 'Must be more than Min Risk')
      .required(),
    maxCriticalWeight: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .moreThan(Yup.ref('maxRiskWeight'), 'Must be more than Max Risk')
      .required(),
    minRiskWeight: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(400, 'Must be less than 400')
      .required(),
    maxRiskWeight: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .max(400, 'Must be less than 400')
      .required(),
    minRiskPef: Yup.number()
      .integer()
      .min(0, 'Must be more than 0')
      .moreThan(Yup.ref('minCriticalPef'), 'Must be more than Min Critical'),
    minCriticalPef: Yup.number().integer().min(0, 'Must be more than 0'),
    minCriticalFev1: Yup.number().min(0, 'Must be more than 0'),
  })
  .nullable()
  .default(null);

export default ClinicThresholdSchema;
